'use strict';

angular.module('shiftTraderApp')
  .directive('saQuickUserInfo', ['$saTooltip', '$saTooltipInteractionSetup', 'Users', 'AvailabilitySets', 'TimeService', '$state', '$rootScope', 'UserPermissionsService',
                                  function($saTooltip, $saTooltipInteractionSetup, Users, AvailabilitySets, TimeService, $state, $rootScope, UserPermissionsService) {
    return {
      template: '<i class="icon-bar-chart"></i>',
      restrict: 'A',
      scope: {
        me: '=',
        user: '=',
        watchUser: '@'
      },
      link: function postLink(scope, elem) {
        scope.state = {
          numWeeksStats: 1,
          //showingAvailability: 'current',
          currentTab: 'shift_density',
          q: {},
          currentPositionId: -1,
          currentPosition: null,
          userSetCurrentPositionId: false,
          canViewTarget: null
        };

        UserPermissionsService.can('availability_sets.view_target', 'current')
          .then(function(result) {
            scope.state.canViewTarget = result;
          });

        scope.timeMarkers = [
          {
            left: '0%',
            label: '12a'
          },
          {
            left: '25%',
            label: '6a'
          },
          {
            left: '50%',
            label: '12p'
          },
          {
            left: '75%',
            label: '6p'
          },
          {
            left: '100%',
            label: '12a'
          }
        ];

        var tooltipInt, tooltip;

        scope.posPieChart = {};
        scope.posPieChart.xFunction = function() {
          return function(d) {
            return d.label;
          };
        };
        scope.posPieChart.yFunction = function() {
          return function(d) {
            return d.value;
          };
        };
        scope.posPieChart.descriptionFunction = function() {
          return function(d) {
            return d.label;
          }
        };

        scope.posPieChart.tooltipFn = function() {
          return function(key, y, e, graph) {
            return '<div class="position_pie_chart_tooltip">' +
                '<div class="position_name">' + key + '</div>' +
                '<div class="position_value">' + y + ' shifts</div>' +
              '</div>';
          };
        };

        scope.state.posPieChartProp = 'numWorkPeriods';
        scope.state.q.showIntervalSelection = function() {
          return lodash.includes(['shift_density', 'positions'], scope.state.currentTab);
        };

        var getAndCalcStats = function() {
          console.log('getAndCalcStats');
          console.trace();
          if (scope.user && scope.user.id) {
            scope.user.$getStatistic('work_hour_distribution', {
              intervalIdent: 'i' + scope.state.numWeeksStats,
              type: 'weekday'
            })
              .then(function(response) {
                scope.barData = [];

                if (response.data.data && response.data.data[0]) {
                  scope.workHourDistStats = response.data.data[0];
                  scope.barData = _.map(scope.workHourDistStats.total, function(val) {
                    if (_.isNull(val)) {
                      return _.map(_.range(48), function() {return 0;});
                    } else {
                      return val;
                    }
                  });

                  scope.systemMax = _.max(_.map(scope.barData, function(datum) {
                    return _.max(datum);
                  }));

                  if (scope.fullUser) {
                    processPositionBarData();
                  }
                }

              }, function() {

              });

            scope.user.$getStatistic('position_distribution', {intervalIdent: 'i' + scope.state.numWeeksStats})
              .then(function(response) {
                if (response.data.data && response.data.data[0]) {
                  var maxPosId = null;
                  var maxPosVal = 0;

                  scope.posPieChart.data = _.map(response.data.data[0].positions, function(pos) {
                    if (_.isNull(maxPosId) || pos.stats[scope.state.posPieChartProp] > maxPosVal) {
                      maxPosVal = pos.stats[scope.state.posPieChartProp];
                      maxPosId = pos.id;
                    }

                    return {
                      label: pos.name,
                      value: pos.stats[scope.state.posPieChartProp]
                    };
                  });

                  if (!scope.state.userSetCurrentPositionId) {
                    scope.state.currentPositionId = maxPosId;
                  }
                }
              }, function() {

              });
          }
        };

        var getUserData = function() {
          if (scope.user && scope.user.id) {
            Users.getById(scope.user.id)
              .then(function(usr) {
                scope.fullUser = usr;

                // TODO: handle not finding a set down below this
                scope.currentSet = _.find(scope.fullUser.availability_sets, function(availSet) {
                  return availSet.$isInEffect() && availSet.$isApproved();
                });

                scope.futureSet = _.find(scope.fullUser.availability_sets, function(availSet) {
                  return !availSet.$isInEffect() && availSet.$isApproved();
                });

                scope.inReviewSet = _.find(scope.fullUser.availability_sets, function(availSet) {
                  return availSet.$isInReview() && availSet.active;
                });

                scope.setShowingAvailability('current');
                $rootScope.$broadcast('availabilitySet:refresh:saQuickUserInfo');

                if (scope.barData) {
                  processPositionBarData();
                }

                if (scope.state.currentPositionId > -1 && !_.isNull(scope.state.currentPositionId)) {
                  scope.state.currentPosition = _.find(scope.fullUser.users_positions, {position_id: parseInt(scope.state.currentPositionId)}).position;
                }



              }, function() {
                console.log('error loading user');
              });
          }
        };

        var setupTooltip = function() {
          tooltip = $saTooltip({
            target: elem.find('.icon-bar-chart'),
            scope: scope,
            templateUrl: 'views/directives/saQuickUserInfo.html',
            tether: {
              attachment: 'top center',
              targetAttachment: 'bottom center',
              offset: '0px 0px',
              targetOffset: '5px 0'
            }
          });

          tooltipInt = new $saTooltipInteractionSetup.setup(tooltip, scope, elem);
          tooltipInt.setCallbacks(function() {
            getAndCalcStats();

            getUserData();
          });
        };

        setupTooltip();



        scope.setTab = function(name) {
          scope.state.currentTab = name;

          if (name === 'availability') {
            if (scope.user && scope.user.id) {
              getPastAvailability();
            }
          }
        };


        var getPastAvailability = function() {
          AvailabilitySets.getAll({
            user_id: scope.user.id,
            state: AvailabilitySets.stateMapping.APPROVED
          })
            .then(function(sets) {
              // need to toss out the current set and future set
              // so if ineffective_date is NULL or in the future toss it
              var nowTime = TimeService.getNowInStoreTime();

              scope.previousAvailabilitySets = _.sortBy(_.where(sets, function(availSet) {
                return !_.isNull(availSet.ineffective_date) && availSet.ineffective_date.isBefore(nowTime);
              }), function(availSet) {
                return availSet.ineffective_date.unix() * -1;
              });

              if (scope.previousAvailabilitySets.length > 0) {
                scope.previousAvailSet = scope.previousAvailabilitySets[0];
              }
              $rootScope.$broadcast('availabilitySet:refresh:saQuickUserInfo');


            }, function() {
              console.log('had a problem');
            });
        };

        var processPositionBarData = function() {
          window.logTime('processPositionBarData');
          // create bar data for positions

          scope.positionBarData = _.map(scope.workHourDistStats.byPosition, function(dayIndexData) {
            if (!_.isNull(dayIndexData.stats)) {
              var positionIds = _.map(_.keys(dayIndexData.stats), function(num){ return parseInt(num);});
            }
            if (_.isNull(dayIndexData.stats) || !_.contains(positionIds, parseInt(scope.state.currentPositionId))) {
              return _.map(_.range(48), function() {return 0;});
            } else {
              return dayIndexData.stats[scope.state.currentPositionId];
            }
          });

          scope.positionBarSystemMax = _.max(_.map(scope.positionBarData, function(datum) {
            return _.max(datum);
          }));
          window.logTime('end processPositionBarData');
        };

        scope.setShowingAvailability = function(name) {
          scope.state.showingAvailability = name;
          scope.state.availabilityViewLinkParams = {
            userId: scope.user.id,
            setId: (function() {
              if (scope.state.showingAvailability === 'current') {
                return scope.currentSet && scope.currentSet.id;
              } else if (scope.state.showingAvailability === 'future') {
                return scope.futureSet && scope.futureSet.id;
              } else if (scope.state.showingAvailability === 'in_review') {
                return scope.inReviewSet && scope.inReviewSet.id;
              } else if (scope.state.showingAvailability === 'previous') {
                return scope.previousAvailSet && scope.previousAvailSet.id;
              }
            }())

          };
        };

        scope.$watch('state.numWeeksStats', function(val, oldVal) {
          if (val !== oldVal) {
            getAndCalcStats();
          }
        });

        scope.setCurrentPositionId = function(posId) {
          scope.state.currentPositionId = posId;
          scope.state.currentPosition = _.find(scope.fullUser.users_positions, {position_id: parseInt(posId)}).position;
          scope.state.userSetCurrentPositionId = true;
          processPositionBarData();
        };

      var userIdWatchDereg = scope.$watch('user.id', function(newVal, oldVal) {
        if (!_.isUndefined(newVal) && newVal !== oldVal) {
          window.logTime('$WATCH user.id ' + newVal + '-' + oldVal);
          scope.currentSet = undefined;
          scope.futureSet = undefined;
          scope.inReviewSet = undefined;
          scope.previousAvailSet = undefined;
          scope.state.currentPositionId = -1;
          scope.state.currentPosition = null;
          scope.state.userSetCurrentPositionId = false;
          setupTooltip();

          if (scope.state.currentTab === 'availability') {
            if (scope.user && scope.user.id) {
              getPastAvailability();
            }
          }

          if (scope.watchUser === 'false') {
            userIdWatchDereg();
          }
        }
      });
      }
    };
  }]);
